import actions from '@/store/modules/usersManagement/suppliers/actions';
import mutations from '@/store/modules/usersManagement/suppliers/mutations';

const state = {
  suppliers: [],
  isLoading: false,
  paginationInfo: {
    pageNumber: 1,
    pageSize: 5,
    sortBy: null,
    sortOrder: 'desc',
  },
  filterQuery: '',
  suppliersTotal: 0,
};

// getters
const getters = {

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
